export default (urlParameters) => {
  const { proForecastId } = urlParameters
  const isSampleRequest = proForecastId === 'sample' || proForecastId === '9999'
  
  return {
    pro_forecast: {
      pro_forecast_id: isSampleRequest ? 14 : proForecastId,
      is_sample_request: isSampleRequest
    }
  }
}